const clusterMemberHelper = (category: 'members' | 'associates' | 'leads') =>
  ({
    BASE: `/resource-base/${category}` as const,

    DETAILS: (clusterMemberId: string) =>
      ({
        BASE: `/resource-base/${category}/${clusterMemberId}` as const,
        CONTACT_INFORMATION: `/resource-base/${category}/${clusterMemberId}/contact-information` as const,
        INFO: `/resource-base/${category}/${clusterMemberId}/info` as const,
        FILES: `/resource-base/${category}/${clusterMemberId}/files` as const,
        INTEREST_AREAS: `/resource-base/${category}/${clusterMemberId}/interest-areas` as const,
        CONTACTS: `/resource-base/${category}/${clusterMemberId}/contacts` as const,
        MEMBER_FEES_AND_EFFORT:
          `/resource-base/${category}/${clusterMemberId}/member-fees-and-effort` as const,
        INVOICES: (year?: string) =>
          `/resource-base/${category}/${clusterMemberId}/invoices/${year ?? ''}` as const,
      }) as const,
  }) as const;

export const RESOURCE_BASE = {
  BASE: '/resource-base',
  MEMBERS: clusterMemberHelper('members'),
  ASSOCIATES: clusterMemberHelper('associates'),
  LEADS: clusterMemberHelper('leads'),
  CONTACTS: {
    BASE: `/resource-base/contacts` as const,
    DETAILS: (clusterContactId: string) =>
      ({
        BASE: `/resource-base/contacts/${clusterContactId}` as const,
        CONTACT_INFORMATION: `/resource-base/contacts/${clusterContactId}/contact-information` as const,
        INTEREST_AREAS: `/resource-base/contacts/${clusterContactId}/interest-areas` as const,
        SELF_EFFORT: `/resource-base/contacts/${clusterContactId}/self-effort` as const,
      }) as const,
  },
} as const;
